var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-toolbar',{staticClass:"header",attrs:{"dense":"","flat":""}},[_c('v-toolbar-title',[_vm._v(" "+_vm._s(_vm.$t("stock.image")))])],1),(
      _vm.singleItem.data &&
      _vm.singleItem.data.images &&
      _vm.singleItem.data.images.length > 0
    )?_c('v-img',{staticClass:"ma-2",staticStyle:{"max-height":"200px"},attrs:{"src":_vm.singleItem.data.images[0],"contain":""}}):_c('v-mdi',{staticStyle:{"max-height":"200px","min-height":"138px","width":"100%"},attrs:{"name":"mdi-image-off"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }